"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PersonWithCrossIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.94 12a6.48 6.48 0 0 0-1.81 4.5c0 1.626.597 3.112 1.583 4.252C8.161 21.448 3 20.68 3 18.446V14c0-1.105.902-2 2.009-2zM9 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8m8.61 5.5 1.161-1.165a.78.78 0 0 0-.003-1.107.79.79 0 0 0-1.112.003L16.5 15.389l-1.156-1.158a.79.79 0 0 0-1.112-.003.78.78 0 0 0-.003 1.11l1.162 1.163-1.162 1.164a.78.78 0 0 0 .003 1.107.79.79 0 0 0 1.112-.003l1.156-1.158 1.156 1.158a.79.79 0 0 0 1.112.003.78.78 0 0 0 .003-1.11zM16.5 22a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11"/></svg>`
}, props));
PersonWithCrossIcon.displayName = 'PersonWithCrossIcon';
var _default = exports.default = PersonWithCrossIcon;